/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { WizardStep, WizardStepProps } from '@squiz/sds';
import React from 'react';
import { DeleteItemDialogContent } from '../../elements/DeleteItemDialogContent/DeleteItemDialogContent';
import { RemainingItemsDialogContent } from '../../elements/RemainingItemsDialogContent/RemainingItemsDialogContent';

export const getDeleteItemDialogSteps = (): Array<WizardStep> => {
  const deleteItemDialogFirstStep: WizardStep = {
    renderStep: (props: WizardStepProps): JSX.Element => <DeleteItemDialogContent {...props} />,
  };
  const deleteItemDialogSecondStep: WizardStep = {
    renderStep: (props: WizardStepProps): JSX.Element => <RemainingItemsDialogContent {...props} />,
  };
  return [deleteItemDialogFirstStep, deleteItemDialogSecondStep];
};
